<template>
  <label
    class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
    :for="htmlId"
  >BAR</label>
  <br />
  <select
    :id="htmlId"
    class="sc3-select-menu sc3-select-menu-inline sc3-select-menu-compact sc3-select-menu-white-and-grey"
    v-model="chartStore.rangeBar"
  >
    <option
      v-for="rangeBarOption in RANGE_BAR_OPTIONS_ARRAY"
      :key="rangeBarOption"
      :value="rangeBarOption"
    >{{ rangeBarOption }}</option>
  </select>
</template>

<script lang="ts" setup>
  import { toRefs } from 'vue';
  import { useChartStore } from '@/stores/chartStore';
  import { RANGE_BAR_OPTIONS_ARRAY } from '@/enums/range-bar-options';

  const chartStore = useChartStore();
  const props = defineProps<{
    htmlId: string;
  }>();
  const { htmlId } = toRefs(props);
</script>
